export const data = [

    {
  
      id: 1,
  
      name: "Pasta con ragu",
  
      searchTerm: "primi",

      description: "Served with parmegiano",
  
      price: 20.99,
  
      image: "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cGFzdGF8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
  
    },
  
    {
  
      id: 2,
  
      name: "Pasta with herbs",
  
      searchTerm: "primi",

      description: "Served with parmegiano",
  
      price: 14.99,
  
      image: "https://images.unsplash.com/photo-1611270629569-8b357cb88da9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
  
    },
  
  
  
    {
  
      id: 3,
  
      name: "Pasta with shrimps",
  
      searchTerm: "primi",

      description: "Served with spicy sauce",
  
      price: 29.99,
  
      image: "https://img.freepik.com/premium-photo/stir-fry-noodles-with-vegetables-shrimps-black-bowl-slate-background-close-up_753131-1802.jpg?w=1380"
  
    },
  
  
  
    {
  
      id: 4,
  
      name: "Grilled meat",
  
      searchTerm: "main",

      description: "Served with spicy sauce",
  
      price: 30.99,
  
      image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fG1lYXR8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
  
    },
  
  
  
    {
  
      id: 5,
  
      name: "Beef steak",
  
      searchTerm: "main",

      description: "Served with potatos",
  
      price: 25.99,
  
      image: "https://images.unsplash.com/photo-1546964124-0cce460f38ef?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
  
    },
  
    {
  
      id: 6,
  
      name: "Chicken wings",
  
      searchTerm: "main",

      description: "Served with tomatos",
  
      price: 28.99,
  
      image: "https://images.unsplash.com/photo-1642497394376-74bf7c38ab23?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2664&q=80"
  
    },
  
    {
  
      id: 7,
  
      name: "Pumpkin Ginger Soup",
  
      searchTerm: "soup",

      description: "Served with garlic bread",
  
      price: 15.99,
  
      image: "https://images.unsplash.com/photo-1613844237701-8f3664fc2eff?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHNvdXB8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
  
    },
  
    {
  
      id: 8,
  
      name: "Red soup gazpacho",
  
      searchTerm: "soup",

      description: "Served with garlic bread",
  
      price: 24.00,
  
      image: "https://images.unsplash.com/photo-1589187154184-995b8a4e740a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
  
    },
  
    {
  
      id: 9,
  
      name: "Soup with cerials",
  
      searchTerm: "soup",

      description: "Served with garlic bread",
  
      price: 18.99,
  
      image: "https://images.unsplash.com/photo-1606791496080-69a6e309f42c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
  
    },
  
    {
  
      id: 10,
  
      name: "Cheesecake",
  
      searchTerm: "dessert",

      description: "Served with Prosecco Lamarca",

      price: 35.99,
  
      image: "https://images.unsplash.com/photo-1524351199678-941a58a3df50?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1771&q=80"
  
    },
  
    {
  
      id: 11,
  
      name: "Tiramisu",
  
      searchTerm: "dessert",

      description: "Served with Chardonnay",
  
      price: 19.99,
  
      image: "https://img.freepik.com/free-photo/high-angle-tiramisu-small-jar_23-2148531563.jpg?w=900&t=st=1669889393~exp=1669889993~hmac=6d929637b2f49519b6a368a5074a16981e69d2f97d3265cebe3a600292576f19"
  
    },
  
    {
  
      id: 12,
  
      name: "Ice cream",
  
      searchTerm: "dessert",

      description: "Served with Chardonnay",
  
      price: 14.99,
  
      image: "https://images.unsplash.com/photo-1618485476424-7dc9cd512c08?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
  
    },
  
    {
  
      id: 13,
  
      name: "Seabass",
  
      searchTerm: "seafood",

      description: "Served with tomatos",
  
      price: 40.99,
  
      image: "https://images.unsplash.com/photo-1599731316783-665e50c66d55?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2674&q=80"
  
    },
  
    {
  
      id: 14,
  
      name: "Shrimps",
  
      searchTerm: "seafood",

      description: "Served with salad",
  
      price: 30.99,
  
      image: "https://images.unsplash.com/photo-1625943553852-781c6dd46faa?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzh8fGZpc2glMjBncmlsbHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
  
    },
  
    {
  
      id: 15,
  
      name: "Salmon",
  
      searchTerm: "seafood",

      description: "Served with tomatos",
  
      price: 24.99,
  
      image: "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80"
  
    }
  
  ]